// @flow
import React, { Component } from 'react';
import moment from 'moment';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover'; // TODO: check for issue about popover https://github.com/mui-org/material-ui/issues/8040
import Menu from 'material-ui/Menu';
import DirectionButton from 'common/components/DirectionButton';

import MonthButton from './MonthButton';
import Month from './Month';

const PickerPopover = styled.div`
  display: flex;
  flex-flow: column;
  width: 320px;
  padding: ${({ theme }) => theme.metrics.smallMargin}px;
  background-color: white;
  text-align: center;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SDivider = styled(Divider)`
  margin: ${({ theme }) => theme.metrics.smallMargin}px 0px !important;
`;

const YearWrapper = styled.div`
  margin: 0px ${({ theme }) => theme.metrics.smallMargin}px;
`;

type HorizontalAnchorOptions = 'left' | 'middle' | 'right';

type Props = {
  selectedDate: Month;
  onSelectMonth: (month: Month) => void;
  primary: boolean;
  secondary: boolean;
  raised: boolean;
  labelStyle?: any;
  minDate?: moment;
  maxDate?: moment;
  horizontalAnchor?: HorizontalAnchorOptions;

  theme: Object;
  t: any;
}

type State = {
  year: number;
  opened?: boolean;
  anchor?: any;
}

class MonthPicker extends Component<Props, State> {

  constructor(props) {
    super(props);
    this.state = {
      year: props.selectedDate.dateInMonth.year(),
      opened: false,
      anchor: null,
    };
  }

  onClick = (event: any) => {
    event.preventDefault();
    this.setState({
      opened: true,
      anchor: event.target,
    });
  }

  onYearButtonClicked = (yearsToAdd: number) => {
    this.setState({ year: this.state.year + yearsToAdd });
  }

  onMonthPicked = (monthValue: number) => {
    const date = moment().year(this.state.year).month(monthValue).date(1);
    this.setState(
      { opened: false },
      () => this.props.onSelectMonth(Month.fromMoment(date)),
    );
  }

  onClose = () => {
    this.setState({
      opened: false,
    });
  }

  getMonthRows = () => {
    const rows = [];
    const monthNamesPerRow = 3;
    const monthNames = moment.monthsShort();
    for (let i = 0; i < 12; i += monthNamesPerRow) {
      rows.push(monthNames.slice(i, i + monthNamesPerRow));
    }
    return rows;
  }

  render() {
    const { t, raised, primary, secondary, labelStyle, selectedDate, minDate, maxDate } = this.props;
    const { year, opened, anchor } = this.state;

    const previousYearIsBeforeMinDate = minDate && (year - 1) < minDate.year();
    const nextYearIsAfterThisYear = maxDate && (year + 1) > moment().year();

    const ButtonComponent = raised ? RaisedButton : FlatButton;

    const extraButtonProps = raised ? {} : {
      labelPosition: 'before',
      icon: <i className="material-icons" style={labelStyle || {}}>keyboard_arrow_down</i>,
    };

    const horizontalAnchor = this.props.horizontalAnchor || 'middle';

    return (
      <React.Fragment>
        <ButtonComponent
          onClick={this.onClick}
          primary={primary}
          secondary={secondary}
          label={t('date.monthAndYear', { value: selectedDate.dateInMonth })}
          {...extraButtonProps}
          labelStyle={labelStyle || {}}
        />
        <Popover
          animated
          open={opened}
          anchorEl={anchor}
          anchorOrigin={{ horizontal: horizontalAnchor, vertical: 'bottom' }}
          targetOrigin={{ horizontal: horizontalAnchor, vertical: 'top' }}
          onRequestClose={this.onClose}
          style={{ backgroundColor: 'transparent' }}
        >
          <Menu desktop listStyle={{ paddingTop: 0, paddingBottom: 0 }} >
            <PickerPopover>
              <Row>
                <DirectionButton
                  direction="left"
                  onClick={() => this.onYearButtonClicked(-1)}
                  disabled={previousYearIsBeforeMinDate}
                />
                <YearWrapper>
                  {year}
                </YearWrapper>
                <DirectionButton
                  direction="right"
                  onClick={() => this.onYearButtonClicked(1)}
                  disabled={nextYearIsAfterThisYear}
                />
              </Row>
              <SDivider />
              {this.getMonthRows().map((row) => {
                return (
                  <Row key={row[0]}>
                    {row.map((monthName) => {
                      return (
                        <MonthButton
                          selectedDate={selectedDate.dateInMonth}
                          monthName={monthName}
                          minDate={minDate}
                          maxDate={maxDate}
                          onClick={this.onMonthPicked}
                          currentYear={year}
                          key={monthName}
                        />
                      );
                    })}
                  </Row>
                );
              })}
            </PickerPopover>
          </Menu>
        </Popover>
      </React.Fragment>
    );
  }
}

export default withTheme(translate('common')(MonthPicker));



// WEBPACK FOOTER //
// ./src/common/components/monthlyDateRangePicker/MonthPicker.js